module.exports = "<md-button class=\"md-fab md-fab-bottom-right docs-scroll-fab\" docs-scroll-class=scrolling ng-click=scrollTop() aria-label=\"Back to Top\" ng-show=$ctrl.atTop1()> <md-tooltip md-direction=top>Back to Top</md-tooltip> <md-icon class=material-icons>keyboard_arrow_up</md-icon> </md-button> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-scroll-top/tsz-scroll-top.html
// module id = 146
// module chunks = 1